<div class="grid p-fluid mt-0">
	<!-- ADD GATEWAY / HIDDEN IF IS SHARED SITE -->
	<div *ngIf="currentSite !== undefined && currentSite?.CurrentlyOwned" class="col-12 pb-0">
		<div class="flex justify-content-center">
			<p-button id="buttonAddDevice" label="{{ 'ADD_DEVICE' | translate }} {{ 'GATEWAY' | lowercase | translate }}"
				(click)="addGateway()" icon="pi cm-plus"
				[rounded]="false" [text]="true" severity="primary"
				styleClass="font-bold border-primary surface-900 hover:bg-blue-900">
			</p-button>
		</div>
	</div>
	<div class="col-12" [class]="onExtendedMobile() ? 'px-0' : ''">
		<p-tabView [scrollable]="true" [activeIndex]="activeIndex" (onChange)="selectedIndexChange($event)"
			styleClass="transparent-tabView">
			<!-- AUTOMATIONS -->
			<p-tabPanel header="{{ 'LIST_DEVICE_AUTOMATIONS' | translate }}">
				<app-device-treetable class="pt-0"></app-device-treetable>
			</p-tabPanel>
			<!-- THERMO -->
			<p-tabPanel header="{{ 'LIST_DEVICE_THERMO' | translate }}">
				<app-devices-th-list></app-devices-th-list>
			</p-tabPanel>
			<!-- VCT -->
			<p-tabPanel header="{{ 'LIST_DEVICE_VCT' | translate }}" *ngIf="!isImpersMode">
				<app-devices-vct-list *ngIf="!editSystem"></app-devices-vct-list>
				<app-devices-vct-list-edit *ngIf="editSystem"></app-devices-vct-list-edit>
			</p-tabPanel>
		</p-tabView>
	</div>
</div>

<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<!-- <button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button> -->
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>